// ข้อมูลบริษัท (ใช้ในหัวจดหมาย/เอกสารทางการ)
export const COMPANY = {
  name_en: 'CAMP STUDIO (THAILAND) CO., LTD.',
  name_th: 'บริษัท แคมป์ สตูดิโอ (ไทยแลนด์) จำกัด',
  address: '412 Sukhumvit 71, Phrakanong Nuea, Wattana, Bangkok 10110',
  tel: '+66 (0)2 096 2566',
  taxId: '0105560181829',
  email: 'info@campstudio.co.th',
  website: 'https://www.campstudio.co.th',
};
